/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  Derived,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type RenderMode = 'PDF' | 'HTML' | unhandledEnumCase;

export const BrandFilterTypename =
  'com.hubspot.sales.documents.models.directory.BrandFilter';
export const BrandFilterDiscriminant = 'BrandFilter';
export const BrandFilterDiscriminantKey = '_type';
export type BrandFilter = {
  brandId: number;
  __typename: 'com.hubspot.sales.documents.models.directory.BrandFilter';
} & { _type?: 'BrandFilter' };

export type CountDirectoryEntriesRequest = {
  filters: Default<DirectoryFilter[]>;
  entryTypes: Default<EntryType[]>;
  folderScope: Default<FolderScope>;
};

export type CountDirectoryEntriesResponse = { totalCount: number };

export type CountSearchResultsRequest = {
  query: string;
  filters: Default<DirectoryFilter[]>;
  entryTypes: Default<EntryType[]>;
  folderScope: Default<FolderScope>;
};

export const CreatedByFilterTypename =
  'com.hubspot.sales.documents.models.directory.CreatedByFilter';
export const CreatedByFilterDiscriminant = 'CreatedByFilter';
export const CreatedByFilterDiscriminantKey = '_type';
export type CreatedByFilter = {
  userId?: number;
  getCurrentUser: Default<boolean>;
  __typename: 'com.hubspot.sales.documents.models.directory.CreatedByFilter';
} & { _type?: 'CreatedByFilter' };

export type DirectoryEntryCreator = {
  firstName?: string;
  lastName?: string;
  email: string;
};

export const DirectoryEntryIFDiscriminantKey = '_type';
export type DirectoryEntryIF = DocumentEntry | FolderEntry;

export const DirectoryFilterDiscriminantKey = '_type';
export type DirectoryFilter =
  | FolderFilter
  | CreatedByFilter
  | TeamFilter
  | BrandFilter;

export type DirectorySort = { field: Field; direction: Default<Direction> };

export const DocumentEntryTypename =
  'com.hubspot.sales.documents.models.directory.DocumentEntry';
export const DocumentEntryDiscriminant = 'DocumentEntry';
export const DocumentEntryDiscriminantKey = '_type';
export type DocumentEntry = {
  brandId?: number;
  lastUsedAt?: number;
  totalViews?: number;
  numShares?: number;
  thumbnailUrl?: string;
  isConsentRequiredToView?: boolean;
  renderMode?: RenderMode;
  isDownloadable: Derived<boolean>;
  id: number;
  name: string;
  createdAt: number;
  updatedAt: number;
  createdByUserId: number;
  createdBy?: DirectoryEntryCreator;
  folderId?: number;
  __typename: 'com.hubspot.sales.documents.models.directory.DocumentEntry';
} & { _type?: 'DocumentEntry' };

export type EntryType = 'DOCUMENT' | 'FOLDER' | unhandledEnumCase;

export const FolderEntryTypename =
  'com.hubspot.sales.documents.models.directory.FolderEntry';
export const FolderEntryDiscriminant = 'FolderEntry';
export const FolderEntryDiscriminantKey = '_type';
export type FolderEntry = {
  id: number;
  name: string;
  createdAt: number;
  updatedAt: number;
  createdByUserId: number;
  createdBy?: DirectoryEntryCreator;
  folderId?: number;
  __typename: 'com.hubspot.sales.documents.models.directory.FolderEntry';
} & { _type?: 'FolderEntry' };

export const FolderFilterTypename =
  'com.hubspot.sales.documents.models.directory.FolderFilter';
export const FolderFilterDiscriminant = 'FolderFilter';
export const FolderFilterDiscriminantKey = '_type';
export type FolderFilter = {
  folderId: number;
  __typename: 'com.hubspot.sales.documents.models.directory.FolderFilter';
} & { _type?: 'FolderFilter' };

export type FolderScope = 'CHILDREN' | 'ALL' | unhandledEnumCase;

export type GetDirectoryEntryRequest = {
  contentId: number;
  entryType: EntryType;
};

export type ListDirectoryEntriesRequest = {
  entryTypes: Default<EntryType[]>;
  folderScope: Default<FolderScope>;
  filters: Default<DirectoryFilter[]>;
  sort: Default<DirectorySort>;
  pageLength: Default<number>;
  offset: Default<number>;
};

export type ListDirectoryEntriesResponse = {
  results: Default<DirectoryEntryIF[]>;
  hasMore: boolean;
  offset: number;
};

export type SearchDirectoryEntriesRequest = {
  query: string;
  entryTypes: Default<EntryType[]>;
  folderScope: Default<FolderScope>;
  filters: Default<DirectoryFilter[]>;
  sort: Default<DirectorySort>;
  pageLength: Default<number>;
  offset: Default<number>;
};

export type SearchDirectoryEntriesResponse = {
  results: Default<DirectoryEntryIF[]>;
  hasMore: boolean;
  offset: number;
};

export const TeamFilterTypename =
  'com.hubspot.sales.documents.models.directory.TeamFilter';
export const TeamFilterDiscriminant = 'TeamFilter';
export const TeamFilterDiscriminantKey = '_type';
export type TeamFilter = {
  teamId?: number;
  getPrimaryTeam: Default<boolean>;
  __typename: 'com.hubspot.sales.documents.models.directory.TeamFilter';
} & { _type?: 'TeamFilter' };

export type Direction = 'ASC' | 'DESC' | unhandledEnumCase;

export type Field =
  | 'NAME'
  | 'CREATED_AT'
  | 'UPDATED_AT'
  | 'CREATED_BY'
  | unhandledEnumCase;

export type DirectoryEntryError = {
  errorType: ErrorType;
  message: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'ENTRY_NOT_FOUND' | 'ACCESS_DENIED' | unhandledEnumCase;

export type ListEntriesRequestType = Requestify<ListDirectoryEntriesRequest>;
export type ListEntriesResponseType = ListDirectoryEntriesResponse;
export type ListEntriesErrorType = EmptyError & HubspotMetadata;
export const listEntriesRpc: ChirpAvroRpcDetails<
  ListEntriesRequestType,
  ListEntriesResponseType,
  ListEntriesErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'listEntries',
  auth: 'app',
  fingerprint: 'sU6bllMdYsrswZfEprWxmpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CountEntriesRequestType = Requestify<CountDirectoryEntriesRequest>;
export type CountEntriesResponseType = CountDirectoryEntriesResponse;
export type CountEntriesErrorType = EmptyError & HubspotMetadata;
export const countEntriesRpc: ChirpAvroRpcDetails<
  CountEntriesRequestType,
  CountEntriesResponseType,
  CountEntriesErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'countEntries',
  auth: 'app',
  fingerprint: 'mR1ucKG2D2pDdktfOPVl4JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SearchEntriesRequestType =
  Requestify<SearchDirectoryEntriesRequest>;
export type SearchEntriesResponseType = SearchDirectoryEntriesResponse;
export type SearchEntriesErrorType = EmptyError & HubspotMetadata;
export const searchEntriesRpc: ChirpAvroRpcDetails<
  SearchEntriesRequestType,
  SearchEntriesResponseType,
  SearchEntriesErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'searchEntries',
  auth: 'app',
  fingerprint: 'oAAGKRulln32Hv7UJIOlL5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CountSearchResultsRequestType =
  Requestify<CountSearchResultsRequest>;
export type CountSearchResultsResponseType = CountDirectoryEntriesResponse;
export type CountSearchResultsErrorType = EmptyError & HubspotMetadata;
export const countSearchResultsRpc: ChirpAvroRpcDetails<
  CountSearchResultsRequestType,
  CountSearchResultsResponseType,
  CountSearchResultsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'countSearchResults',
  auth: 'app',
  fingerprint: 'y7ptrL3LtMBDdktfOPVl4JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetEntryRequestType = Requestify<GetDirectoryEntryRequest>;
export type GetEntryResponseType = DirectoryEntryIF;
export type GetEntryErrorType = DirectoryEntryError & HubspotMetadata;
export const getEntryRpc: ChirpAvroRpcDetails<
  GetEntryRequestType,
  GetEntryResponseType,
  GetEntryErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentIndexRpc',
  rpcName: 'getEntry',
  auth: 'app',
  fingerprint: 'gf-uyukticHYWCZaWxTyh2-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
